module.exports = __webpack_public_path__ + "not-found-bkg.png";